import { Button, Group } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';

import { AccessDenied } from 'src/Components/AccessDenied';
import { InstructionList } from 'src/Components/Instructions/InstructionList';
import { VideoTutorialButton } from 'src/Components/Shared/VideoTutorialButton';
import { useFetchAssetDetails } from 'src/Hooks/Queries/useFetchAssetDetails';
import { useCanCreate, useCanRead } from 'src/Hooks/Shared/useHasPermission';
import { useIsAssetAboveQuotas } from 'src/Hooks/Shared/useIsAssetAboveQuotas';

import styles from './InstructionsMainPage.module.scss';

const InstructionsMainPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: asset } = useFetchAssetDetails();

  // Permission checks
  const { hasPermission: canRead, ownerName } = useCanRead('instruction');
  const { hasPermission: canCreate } = useCanCreate('instruction');

  const assetAboveQuotas = useIsAssetAboveQuotas();

  const createInstruction = useCallback(() => {
    if (!asset) return;

    navigate('new');
  }, [asset, navigate]);

  // Show access denied if user doesn't have read permission
  if (!canRead) {
    return <AccessDenied ownerName={ownerName} />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.topLine}>
        <div className={styles.titleColumn}>
          <div className={styles.title}>{t('instructions.title', 'Consignes')}</div>
          <div className={styles.subtitle}>
            {t(
              'instructions.subtitle',
              'Retrouvez ici toutes les instructions pour le bon fonctionnement de la maison'
            )}
          </div>
        </div>
        <Group>
          <VideoTutorialButton videoUrl={'https://youtu.be/urBnR5owoqE'} />
          {canCreate && (
            <Button
              onClick={() => createInstruction()}
              leftSection={<IconPlus size={20} />}
              disabled={assetAboveQuotas}
            >
              {t('instructions.addInstructions', 'Ajouter une consigne')}
            </Button>
          )}
        </Group>
      </div>
      <InstructionList />

      <Outlet />
    </div>
  );
};

export default InstructionsMainPage;
